/* LOFTfifty6 voorpagina — bewegingssysteem (ontwerp-integratie 27-07-2026) */
(function () {
  'use strict';
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';
  var root = document.querySelector('[data-lf-page]');
  if (!root) return;

  var intro = root.querySelector('[data-lf-intro]');
  var introDone = calm || sessionStorage.getItem('lf6-intro') === '1';
  if (intro && introDone) intro.style.display = 'none';
  if (!introDone) sessionStorage.setItem('lf6-intro', '1');

  /* converge-elementen beginnen licht verschoven en glijden op hun plek */
  var convs = root.querySelectorAll('[data-cx],[data-cy]');
  if (!calm) {
    convs.forEach(function (el) {
      var x = parseFloat(el.dataset.cx || '0');
      var y = parseFloat(el.dataset.cy || '0');
      el.style.opacity = '0';
      el.style.transform = 'translate(' + x + 'px,' + (y * 2) + 'px)';
    });
  }

  var stickyBar = root.querySelector('[data-lf-sticky]');
  var mx = 0, my = 0, smx = 0, smy = 0, t0 = null;
  window.addEventListener('mousemove', function (ev) {
    mx = (ev.clientX / window.innerWidth - 0.5) * 2;
    my = (ev.clientY / window.innerHeight - 0.5) * 2;
  }, { passive: true });

  if (calm) {
    if (intro) intro.style.display = 'none';
    convs.forEach(function (el) { el.style.opacity = ''; el.style.transform = ''; });
    if (stickyBar) stickyBar.classList.add('is-zichtbaar');
    return;
  }

  function frame() {
    requestAnimationFrame(frame);
    var vh = window.innerHeight;

    var stage = root.querySelector('[data-lf-hero]');
    if (stage) {
      if (!t0) t0 = performance.now();
      var t = performance.now() - t0;
      if (intro && intro.style.display !== 'none') {
        var li0 = Math.min(1, t / 750);
        var li = li0 * li0 * (3 - 2 * li0);
        var lg = intro.firstElementChild;
        if (lg) { lg.style.opacity = String(li); lg.style.transform = 'scale(' + (0.94 + 0.06 * li).toFixed(4) + ')'; }
        var out0 = Math.min(1, Math.max(0, (t - 1450) / 850));
        var out = out0 * out0 * (3 - 2 * out0);
        intro.style.opacity = String(1 - out);
        if (out >= 1) intro.style.display = 'none';
      }
      var introT = introDone ? 1 : Math.min(1, Math.max(0, (t - 1500) / 1200));
      var ii = introT * introT * (3 - 2 * introT);
      convs.forEach(function (el) {
        if (ii >= 1) { el.style.opacity = ''; el.style.transform = ''; return; }
        var x = parseFloat(el.dataset.cx || '0');
        var y = parseFloat(el.dataset.cy || '0');
        el.style.opacity = String(ii);
        el.style.transform = 'translate(' + (x * (1 - ii)).toFixed(1) + 'px,' + (y * 2 * (1 - ii)).toFixed(1) + 'px)';
      });
      smx += (mx - smx) * 0.06;
      smy += (my - smy) * 0.06;
      var span = stage.offsetHeight - vh;
      var p = span > 0 ? -stage.getBoundingClientRect().top / span : 0;
      p = Math.max(0, Math.min(1, p));
      var ez = p * p * (3 - 2 * p);
      var zoom = 1.04 + 0.2 * ez;
      var wrap = stage.querySelector('[data-lf-par-wrap]');
      if (wrap) wrap.style.transform =
        'translate(' + (smx * -0.5).toFixed(3) + 'vw,' + (smy * -0.35).toFixed(3) + 'vh) scale(' + zoom.toFixed(4) + ')';
      var copy = stage.querySelector('[data-lf-hero-copy]');
      if (copy) {
        var cOut = Math.max(0, Math.min(1, (p - 0.8) / 0.2));
        copy.style.transform = 'translateY(' + ((-cOut * 26) + (1 - ii) * 22).toFixed(1) + 'px)';
        copy.style.opacity = String(Math.min(ii, 1 - cOut));
      }
      var hint = stage.querySelector('[data-lf-hero-hint]');
      if (hint) hint.style.opacity = String(Math.max(0, 1 - p * 6));
      if (stickyBar) stickyBar.classList.toggle('is-zichtbaar', p > 0.55);
    }

    var bands = Array.prototype.slice.call(root.children);
    bands.forEach(function (el, bi) {
      if (bi === 0 || el.dataset.lfShown) return;
      if (getComputedStyle(el).position === 'fixed' || el.offsetHeight < 40) return;
      var top = el.getBoundingClientRect().top;
      if (!el.dataset.lfPrimed) {
        el.dataset.lfPrimed = '1';
        if (top < vh * 0.9) { el.dataset.lfShown = '1'; return; }
        var kids = Array.prototype.filter.call(el.children, function (c) { return c.offsetHeight > 20; });
        if (kids.length > 1 && kids.length <= 14) {
          el.dataset.lfBand = '1';
          el.style.perspective = '1100px';
          kids.forEach(function (c) {
            c.style.opacity = '0';
            c.style.transformOrigin = '50% 100%';
            c.style.transform = 'translateY(30px) rotateX(14deg) scale(.98)';
          });
        } else {
          el.style.opacity = '0';
          el.style.transform = 'translateY(30px)';
        }
        return;
      }
      if (top < vh * 0.9) {
        el.dataset.lfShown = '1';
        el.dataset.lfT = String(performance.now());
        el.style.transition = 'opacity 1.05s ' + EASE + ',transform 1.15s ' + EASE;
        el.style.opacity = '1';
        el.style.transform = 'none';
        if (el.dataset.lfBand) {
          var kids2 = Array.prototype.slice.call(el.children);
          var step = kids2.length > 8 ? 55 : 85;
          kids2.forEach(function (c, i) {
            if (c.style.opacity !== '0') return;
            c.style.transition = 'opacity .9s ' + EASE + ' ' + (i * step) + 'ms,transform 1s ' + EASE + ' ' + (i * step) + 'ms';
            c.style.opacity = '1';
            c.style.transform = 'none';
          });
        }
      }
    });

    var bandReady = function (el) {
      var band = el.closest('[data-lf-band]');
      return !band || (band.dataset.lfShown && performance.now() - parseFloat(band.dataset.lfT || '0') > 1250);
    };
    root.querySelectorAll('[data-lf-drift]').forEach(function (el) {
      if (!bandReady(el)) return;
      var r = el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      var rel = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translateY(' + (rel * parseFloat(el.dataset.lfDrift)).toFixed(1) + 'px)';
    });
    root.querySelectorAll('[data-lf-pan]').forEach(function (im) {
      if (!bandReady(im)) return;
      var c = (im.parentElement || im).getBoundingClientRect();
      if (c.bottom < 0 || c.top > vh) return;
      var rel = (c.top + c.height / 2 - vh / 2) / vh;
      im.style.transform = 'translateY(' + (rel * parseFloat(im.dataset.lfPan)).toFixed(2) + '%) rotateX(' + (rel * -3).toFixed(2) + 'deg) scale(1.13)';
    });

    root.querySelectorAll('[data-lf-tilt]').forEach(function (card) {
      if (card.dataset.lfTiltOn) return;
      card.dataset.lfTiltOn = '1';
      card.style.transformStyle = 'preserve-3d';
      if (card.parentElement) card.parentElement.style.perspective = '900px';
      var media = card.firstElementChild;
      var glare = document.createElement('div');
      glare.style.cssText = 'position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s ease;z-index:3';
      if (media) { media.style.position = 'relative'; media.appendChild(glare); }
      card.addEventListener('mousemove', function (ev) {
        var r = card.getBoundingClientRect();
        var nx = (ev.clientX - r.left) / r.width - 0.5;
        var ny = (ev.clientY - r.top) / r.height - 0.5;
        card.style.transition = 'transform .12s ease-out';
        card.style.transform = 'rotateY(' + (nx * 9).toFixed(2) + 'deg) rotateX(' + (-ny * 9).toFixed(2) + 'deg) translateZ(12px)';
        glare.style.opacity = '1';
        glare.style.background = 'radial-gradient(420px circle at ' + ((nx + 0.5) * 100).toFixed(1) + '% ' + ((ny + 0.5) * 100).toFixed(1) + '%,rgba(255,255,255,.3),transparent 55%)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transition = 'transform .8s ' + EASE;
        card.style.transform = 'none';
        glare.style.opacity = '0';
      });
    });

    root.querySelectorAll('img').forEach(function (im) {
      if (im.dataset.lfNoZoom) return;
      if (!im.dataset.lfZoom) {
        if (/logo/.test(im.getAttribute('src') || '') || im.closest('[data-lf-hero]') || im.closest('.lf-marq') || im.offsetHeight < 300) {
          im.dataset.lfNoZoom = '1';
          return;
        }
        im.dataset.lfZoom = '1';
        if (im.parentElement) im.parentElement.style.overflow = 'hidden';
      }
      var r = im.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var d = Math.min(1, Math.abs((r.top + r.height / 2 - vh / 2) / vh));
      im.style.transform = 'scale(' + (1 + 0.03 * d * d).toFixed(4) + ')';
    });
  }
  requestAnimationFrame(frame);
})();
